<template>
  <v-dialog
    v-model="dialog"
    max-width="520"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-if="!noActivator" v-slot:activator="{ on, attrs }">
      <v-btn
        block
        depressed
        color="accent"
        class="rounded-lg stc__add"
        v-on="on"
        v-bind="attrs"
      >
        <hero-icon :icon="UserPlusIcon" :size="16" class="stc__add-icon" />
        Nuevo miembro
      </v-btn>
    </template>

    <v-card class="stc rounded-lg">
      <!-- header -->
      <div class="stc__head">
        <div class="stc__head-text">
          <h2 class="stc__title">Nuevo miembro</h2>
          <p class="stc__sub">
            Ingresá las credenciales y los datos de contacto.
          </p>
        </div>
        <button
          type="button"
          class="stc__close"
          @click="dialog = false"
          aria-label="Cerrar"
        >
          <hero-icon :icon="XMarkIcon" :size="18" />
        </button>
      </div>

      <div class="stc__divider"></div>

      <!-- body -->
      <div class="stc__body">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="createStaff"
        >
          <!-- Credenciales -->
          <p class="stc__section">Credenciales</p>

          <div class="stc__row">
            <v-text-field
              label="E-mail"
              v-model="userAttributes.email"
              :rules="required"
              outlined
              dense
              class="stc__field"
            >
              <template v-slot:prepend-inner>
                <hero-icon :icon="EnvelopeIcon" :size="18" class="stc__icon" />
              </template>
            </v-text-field>

            <v-text-field
              label="Contraseña"
              v-model="userAttributes.password"
              :rules="required"
              type="password"
              outlined
              dense
              class="stc__field"
            >
              <template v-slot:prepend-inner>
                <hero-icon :icon="LockClosedIcon" :size="18" class="stc__icon" />
              </template>
            </v-text-field>
          </div>

          <v-select
            label="Permisos"
            v-model="role"
            :items="userRoles"
            :rules="required"
            outlined
            dense
            class="stc__field"
          >
            <template v-slot:prepend-inner>
              <hero-icon :icon="KeyIcon" :size="18" class="stc__icon" />
            </template>
          </v-select>

          <!-- Datos de contacto -->
          <p class="stc__section">Datos de contacto</p>

          <div class="stc__row">
            <v-text-field
              label="Nombre"
              v-model="attributes.name"
              :rules="required"
              outlined
              dense
              class="stc__field"
            >
              <template v-slot:prepend-inner>
                <hero-icon :icon="UserIcon" :size="18" class="stc__icon" />
              </template>
            </v-text-field>

            <v-text-field
              label="Número de teléfono"
              v-model="attributes.number"
              :rules="required"
              outlined
              dense
              class="stc__field"
            >
              <template v-slot:prepend-inner>
                <hero-icon :icon="PhoneIcon" :size="18" class="stc__icon" />
              </template>
            </v-text-field>
          </div>

          <div class="stc__row">
            <v-select
              label="Tipo de operación"
              v-model="attributes.operationType"
              :items="operationTypes"
              :rules="required"
              outlined
              dense
              class="stc__field"
            >
              <template v-slot:prepend-inner>
                <hero-icon :icon="BriefcaseIcon" :size="18" class="stc__icon" />
              </template>
            </v-select>

            <v-select
              label="Cargo"
              v-if="
                attributes.operationType && attributes.operationType == 'rent'
              "
              v-model="attributes.rol"
              :items="roles"
              :rules="required"
              outlined
              dense
              class="stc__field"
            >
              <template v-slot:prepend-inner>
                <hero-icon :icon="TagIcon" :size="18" class="stc__icon" />
              </template>
            </v-select>
          </div>

          <v-select
            label="Tipo de propiedad"
            v-model="attributes.propertyTypes"
            multiple
            :items="propertyTypes"
            outlined
            dense
            class="stc__field"
          ></v-select>

          <v-select
            label="Sucursal"
            v-model="attributes.city"
            :items="cities"
            outlined
            dense
            class="stc__field"
          >
            <template v-slot:prepend-inner>
              <hero-icon :icon="MapPinIcon" :size="18" class="stc__icon" />
            </template>
          </v-select>

          <!-- footer -->
          <div class="stc__actions">
            <v-btn text color="primary" class="rounded-lg" @click="dialog = false">
              Cancelar
            </v-btn>
            <v-btn
              type="submit"
              color="accent"
              depressed
              class="rounded-lg"
            >
              Crear miembro
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { CreateStaff } from "@/graphql/mutations/staff";
import HeroIcon from "@/components/shared/HeroIcon";
import XMarkIcon from "heroicons/24/outline/x-mark.svg";
import UserPlusIcon from "heroicons/24/outline/user-plus.svg";
import EnvelopeIcon from "heroicons/24/outline/envelope.svg";
import LockClosedIcon from "heroicons/24/outline/lock-closed.svg";
import UserIcon from "heroicons/24/outline/user.svg";
import PhoneIcon from "heroicons/24/outline/phone.svg";
import KeyIcon from "heroicons/24/outline/key.svg";
import BriefcaseIcon from "heroicons/24/outline/briefcase.svg";
import TagIcon from "heroicons/24/outline/tag.svg";
import MapPinIcon from "heroicons/24/outline/map-pin.svg";

export default {
  components: { HeroIcon },

  data() {
    return {
      XMarkIcon,
      UserPlusIcon,
      EnvelopeIcon,
      LockClosedIcon,
      UserIcon,
      PhoneIcon,
      KeyIcon,
      BriefcaseIcon,
      TagIcon,
      MapPinIcon,
      dialog: false,
      valid: true,
      roles: ["Visitas", "Administración"],
      cities: ["Reconquista", "Avellaneda"],
      operationTypes: [
        {
          text: "Ventas",
          value: "sell"
        },
        {
          text: "Alquileres",
          value: "rent"
        }
      ],
      propertyTypes: [
        {
          text: this.$t(
            "property.create.type.fields.property_types.country_house"
          ),
          value: "country_house"
        },
        {
          text: this.$t("property.create.type.fields.property_types.apartment"),
          value: "apartment"
        },
        {
          text: this.$t("property.create.type.fields.property_types.salon"),
          value: "salon"
        },
        {
          text: this.$t("property.create.type.fields.property_types.warehouse"),
          value: "warehouse"
        },
        {
          text: this.$t("property.create.type.fields.property_types.parking"),
          value: "parking"
        },
        {
          text: this.$t("property.create.type.fields.property_types.shed"),
          value: "shed"
        },
        {
          text: this.$t("property.create.type.fields.property_types.house"),
          value: "house"
        },
        {
          text: this.$t("property.create.type.fields.property_types.farm"),
          value: "farm"
        },
        {
          text: this.$t("property.create.type.fields.property_types.terrain"),
          value: "terrain"
        }
      ],
      required: [v => !!v || "Campo obligatorio"],
      role: null,
      userRoles: [
        {
          text: "Gerente",
          value: "admin"
        },
        {
          text: "Ventas",
          value: "sales"
        },
        {
          text: "Administración",
          value: "gendev"
        },
        {
          text: "Propiedades",
          value: "properties"
        }
      ],
      userAttributes: {
        email: null,
        password: null
      },
      attributes: {
        name: null,
        rol: null,
        operationType: null,
        propertyTypes: [],
        number: null,
        city: null
      }
    };
  },

  props: {
    noActivator: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    open() {
      this.dialog = true;
    },

    createStaff() {
      if (this.$refs.form.validate()) {
        this.$apollo
          .mutate({
            mutation: CreateStaff,
            variables: {
              input: {
                attributes: this.attributes,
                userAttributes: this.userAttributes,
                role: this.role
              }
            }
          })
          .then(res => {
            this.$emit("reload");
            this.$refs.form.reset();
            this.dialog = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.stc {
  background: #fff;
  border: 1px solid #ece7de;
}

/* activator */
.stc__add {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
}
.stc__add-icon {
  margin-right: 6px;
}

/* header */
.stc__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 16px;
}
.stc__title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1814;
  margin: 0;
  line-height: 1.2;
}
.stc__sub {
  font-size: 13px;
  color: #756f64;
  margin: 5px 0 0;
}
.stc__close {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: #a39a8c;
  transition: background 0.15s ease, color 0.15s ease;
}
.stc__close:hover {
  background: #f1ece3;
  color: #1a1814;
}

.stc__divider {
  height: 1px;
  background: #ece7de;
}

/* body */
.stc__body {
  padding: 20px 24px 22px;
}

/* section labels */
.stc__section {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #a39a8c;
  margin: 0 0 12px;
}
.stc__section:not(:first-child) {
  margin-top: 8px;
}

/* two-column rows */
.stc__row {
  display: flex;
  gap: 12px;
}
.stc__row > .stc__field {
  flex: 1;
  min-width: 0;
}
@media (max-width: 540px) {
  .stc__row {
    flex-direction: column;
    gap: 0;
  }
}

.stc__icon {
  color: #a39a8c;
  margin-right: 6px;
  align-self: center;
}

/* footer */
.stc__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
}

/* rounded outlined fieldsets */
.stc__field >>> .v-text-field--outlined fieldset,
.stc__field >>> .v-select fieldset {
  border-radius: 10px;
}
.stc__field >>> .v-input__slot {
  transition: border-color 0.15s ease;
}
</style>
